import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var StarSquareIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#star-square__a)",
                            children: [
                                _jsx("path", {
                                    d: "M20.765 23.35H3.245c-.69 0-1.34-.27-1.83-.76-.48-.48-.76-1.15-.76-1.83V3.24c0-.69.27-1.34.76-1.83s1.14-.76 1.83-.76h17.51c.69 0 1.34.27 1.83.76s.76 1.14.76 1.83v17.51c0 .68-.28 1.35-.76 1.83-.49.49-1.14.76-1.83.76l.01.01zM3.245 2.65a.59.59 0 00-.42.17.59.59 0 00-.17.42v17.51c0 .16.06.31.17.42.11.11.26.17.42.17h17.51c.16 0 .31-.06.42-.17a.59.59 0 00.17-.42V3.24a.59.59 0 00-.17-.42.59.59 0 00-.42-.17H3.245z"
                                }),
                                _jsx("path", {
                                    d: "M15.155 18.33c-.25 0-.51-.07-.74-.2l-2.42-1.28-2.46 1.3c-.21.12-.49.2-.78.18-.27-.01-.54-.1-.77-.27a1.473 1.473 0 01-.58-1.49l.46-2.75-1.99-1.91c-.21-.21-.34-.45-.4-.71a1.454 1.454 0 011.18-1.78l2.78-.41 1.24-2.51c.11-.23.29-.44.52-.58.23-.15.49-.23.76-.23.27-.03.55.07.78.21.23.14.42.34.55.58L14.535 9l2.77.42c.25.03.51.15.73.32a1.468 1.468 0 01.47 1.5c-.07.27-.21.51-.42.7l-1.92 1.82.41 2.88c.05.22.02.5-.08.76s-.28.49-.51.66c-.23.17-.5.26-.79.27h-.08.04zm-3.15-3.54c.22 0 .43.05.63.13l1.85.98-.27-1.89c-.05-.15-.08-.31-.08-.47 0-.23.06-.47.17-.68.05-.1.12-.18.2-.26l1.45-1.38-1.96-.3c-.2-.02-.44-.11-.64-.26-.21-.15-.37-.36-.47-.59l-.86-1.73-.89 1.79a1.417 1.417 0 01-1.15.8l-1.9.28 1.44 1.38s.06.06.09.1c.15.19.25.41.3.64.04.2.03.41-.02.62l-.32 1.92 1.76-.93c.26-.12.47-.16.69-.16l-.02.01z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "star-square__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
StarSquareIcon.isCarinaIcon = true;
export default StarSquareIcon;
